module.exports = __webpack_public_path__ + "img/veg.7edf6e22.svg";